// src/hooks/usePurchaseSetup.js
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import {
  Purchases as PurchasesNative,
  LOG_LEVEL as LOG_LEVEL_NATIVE
} from '@revenuecat/purchases-capacitor';
import { Purchases as PurchasesWeb } from '@revenuecat/purchases-js';

const googleKey = process.env.REACT_APP_REVENUECAT_GOOGLE_KEY;
const appleKey  = process.env.REACT_APP_REVENUECAT_IOS_KEY;
const webKey    = process.env.REACT_APP_REVENUECAT_WEB_API_KEY;

export function usePurchaseSetup() {
  useEffect(() => {
    const platform = Capacitor.getPlatform();
    const isNative = platform === 'ios' || platform === 'android';

    if (isNative) {
      console.log('[RC] running NATIVE setup on', platform);
      // Native: configure once
      PurchasesNative.setLogLevel({ level: LOG_LEVEL_NATIVE.DEBUG });
      PurchasesNative.configure({
        apiKey:
          Capacitor.getPlatform() === 'ios' ? appleKey : googleKey,
        observerMode: false
      });
    } else {
      // Web: initialize with an anon ID (we’ll swap once they log in)
      console.log('[RC] running WEB setup');
      let anon = localStorage.getItem('rc_app_user_id');
      if (!anon) {
        anon = PurchasesWeb.generateRevenueCatAnonymousAppUserId();
        localStorage.setItem('rc_app_user_id', anon);
      }
      PurchasesWeb.configure(webKey, anon);
    }
  }, []);
}
